import { jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { FlexRow } from '@xyo-network/sdk-xyo-react-js';
import { DateTime } from 'luxon';
const Copyright = (props) => {
    return (_jsxs(Typography, Object.assign({ component: FlexRow, variant: "body2" }, props, { children: ["COIN \u00A9 - ", DateTime.now().year, " All Rights Reserved"] }), void 0));
};
export default Copyright;
//# sourceMappingURL=Copyright.js.map